import { render, staticRenderFns } from "./GlobalSearchResultsEmpty.vue?vue&type=template&id=4789b3d9&"
import script from "./GlobalSearchResultsEmpty.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchResultsEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearchResultsEmpty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports